export interface CourseModule {
  number: string
  title: string
  hook: string
  description: string
  closer: string
  tags: string[]
}

export const modules: CourseModule[] = [
  {
    number: '01',
    title: 'Senior Movement Library™',
    hook: 'See the movement. Choose the level. Start coaching.',
    description:
      'Build your exercise selection from a professional visual library created specifically for older adult fitness. Instead of searching for another exercise every time you plan a class, quickly find practical movements organized around the physical qualities you actually train.',
    closer:
      'Use the movements individually or combine them throughout the rest of the system.',
    tags: [
      'Strength',
      'Mobility',
      'Balance',
      'Coordination',
      'Functional Movement',
      'Chair Options',
      'Progressions',
    ],
  },
  {
    number: '02',
    title: 'Ready-To-Teach Class Library™',
    hook: "Your next class doesn't have to be built from scratch.",
    description:
      'Move beyond individual exercises and open complete senior fitness classes already structured for you. Choose from different durations, goals, formats and ability levels — then adapt the session to your group with visual class structures, circuits, training stations and activities.',
    closer: 'Choose it. Adapt it. Teach it.',
    tags: [
      '30-Minute',
      '45-Minute',
      '60-Minute',
      'Strength',
      'Balance',
      'Mobility',
      'Functional',
      'Cardio',
      'Circuits',
      'Stations',
    ],
  },
  {
    number: '03',
    title: 'Senior Strength & Functional Training™',
    hook: 'Build the strength that supports real life.',
    description:
      'Bring more structure and variety into senior strength training with practical workouts, gym-based activities and functional movement combinations. Work the patterns that matter for active aging using dumbbells, resistance bands, steps, chairs and other senior-friendly equipment.',
    closer:
      'From individual strength activities to complete functional workouts.',
    tags: [
      'Lower Body',
      'Upper Body',
      'Push',
      'Pull',
      'Carry',
      'Step',
      'Functional Strength',
      'Gym Circuits',
      'Resistance Training',
    ],
  },
  {
    number: '04',
    title: 'Balance, Coordination & Active Movement™',
    hook: 'Make balance training more dynamic, varied and practical.',
    description:
      'Go beyond repeating the same static balance drills. Use visual activities designed around stability, coordination, reaction, movement confidence and controlled changes of direction — with cones, targets, stepping patterns, balls, movement games and structured challenges.',
    closer: 'Professional activities that keep senior fitness sessions moving.',
    tags: [
      'Static Balance',
      'Dynamic Balance',
      'Coordination',
      'Reaction',
      'Direction Changes',
      'Obstacle Activities',
      'Indoor & Outdoor',
    ],
  },
  {
    number: '05',
    title: 'Mobility & Active Aging™',
    hook: 'Move better. Prepare better. Recover better.',
    description:
      'Access visual mobility sequences and practical activities that can be used throughout your senior fitness programming — as warm-ups, dedicated mobility sessions, movement preparation, active recovery or cool-downs.',
    closer: 'Easy to see. Easy to select. Easy to integrate into your classes.',
    tags: [
      'Ankles',
      'Hips',
      'Spine',
      'Shoulders',
      'Full-Body Mobility',
      'Warm-Ups',
      'Cool-Downs',
      'Mobility Flows',
      'Active Recovery',
    ],
  },
  {
    number: '06',
    title: '12-Month Programming & Progression System™',
    hook: 'Stop planning one class at a time.',
    description:
      'Exercises are useful. Classes are better. But professional programming requires knowing what comes next. This module connects the entire system into a longer-term structure so you can organize exercises, sessions, strength, balance, mobility and functional training across weeks and months instead of starting over every Monday.',
    closer:
      'See how activities become sessions, sessions become weeks, and weeks become a complete program.',
    tags: [
      'Weekly Planning',
      'Monthly Programming',
      'Training Blocks',
      'Exercise Progressions',
      'Class Progressions',
      'Variety',
      'Ability Levels',
      'Long-Term Structure',
    ],
  },
]
